/**
 * Reyting — docs/SPEC.md §top, X-7.
 *
 * **Ikkita o'q, ikkita alohida jadval** (D-003):
 *
 *   [ Charm ]  [ Level ]        ← asosiy
 *   [ Bugun ][ Hafta ][ Oy ]    ← ikkinchi daraja
 *
 * Prototipda faqat vaqt tablari bor edi va ball `ic-gem` bilan
 * ko'rsatilgandi — bu "bitta sotib olinadigan reyting" taassurotini
 * berardi. Shuning uchun charm uchun `ic-heart` `--pink`, level uchun
 * `ic-mic` `--blue`: ikkalasi turli narsa ekani RANGDAN ham ko'rinadi.
 *
 * Pullik ko'tarish YO'Q (qoida 8).
 */

import { useState } from 'react';

import { uz } from '../i18n/uz';
import { fmt } from '../lib/format';
import { useLeaderboard, type TopEntry } from '../lib/api/useRoom';
import { Avatar, Chip, Icon } from '../ui';
import './screens.css';

type Axis = 'charm' | 'level';
type Period = 'today' | 'week' | 'month';

const PERIODS: Period[] = ['today', 'week', 'month'];

export function Top() {
  const [axis, setAxis] = useState<Axis>('charm');
  const [period, setPeriod] = useState<Period>('week');

  const board = useLeaderboard(axis, period);
  const items = board.data?.items ?? [];
  const me = board.data?.me ?? null;

  // O'z o'rnim ro'yxatda ko'rinsa pastda takrorlamaymiz.
  const meShown = items.some((entry) => entry.is_me);

  return (
    <div className="screen">
      {/* Dockli ekran — o'z orqaga tugmasi YO'Q (SPEC §336: u faqat
          fokusli ekranlarda). Chiqish yo'li dock orqali. */}
      <h1 className="screen-bar__title">{uz.top.title}</h1>

      {/* Asosiy o'q — ikkita alohida jadval */}
      <div className="chip-row" style={{ marginTop: 18 }}>
        <Chip className="chip--age" active={axis === 'charm'} onClick={() => setAxis('charm')}>
          {uz.top.charm}
        </Chip>
        <Chip className="chip--age" active={axis === 'level'} onClick={() => setAxis('level')}>
          {uz.top.level}
        </Chip>
      </div>

      <div className="chip-row" style={{ marginTop: 10 }}>
        {PERIODS.map((value) => (
          <Chip
            key={value}
            className="chip--lang"
            active={period === value}
            onClick={() => setPeriod(value)}
          >
            {uz.top.period[value]}
          </Chip>
        ))}
      </div>

      {board.isLoading ? (
        <div className="muted" style={{ marginTop: 20 }}>
          {uz.common.loading}
        </div>
      ) : board.isError ? (
        /* Xato holati — ilgari bu yerda YOLG'ON bo'sh holat chiqardi
           ("hali sovg'a berilmagan"), aslida so'rov yiqilgan bo'lardi. */
        <div className="panel error" style={{ marginTop: 20 }}>
          {uz.common.error}
        </div>
      ) : items.length === 0 ? (
        <div className="empty" style={{ marginTop: 40 }}>
          {axis === 'charm' ? uz.top.emptyCharm : uz.top.emptyLevel}
        </div>
      ) : (
        <div style={{ marginTop: 18 }}>
          {items.map((entry) => (
            <Row key={entry.user_id} entry={entry} axis={axis} />
          ))}
        </div>
      )}

      {/* O'z o'rnim — TOP dan tashqarida bo'lsa ham (SPEC X-7). */}
      {me && !meShown && (
        <>
          <div className="section-head">
            <span className="section-head__title">{uz.top.you}</span>
            <span className="section-head__rule" />
          </div>
          <Row entry={me} axis={axis} />
        </>
      )}

      <div className="screen-tail" />
    </div>
  );
}

function Row({ entry, axis }: { entry: TopEntry; axis: Axis }) {
  return (
    <div className={entry.is_me ? 'top-row top-row--me' : 'top-row'}>
      <span className="top-row__rank tnum">{entry.rank}</span>
      <Avatar letter={entry.first_name.slice(0, 1)} paletteIdx={entry.palette_idx} size={36} />
      <span className="top-row__name">{entry.first_name}</span>
      <span className={axis === 'charm' ? 'top-row__value is-charm' : 'top-row__value is-level'}>
        <Icon name={axis === 'charm' ? 'heart' : 'mic'} size={13} />
        <span className="tnum">{fmt(entry.value)}</span>
      </span>
    </div>
  );
}
